import React, { useState, useEffect } from "react";
import { Typewriter } from "react-simple-typewriter";
import styles from "./HeadlineTicker.module.css";
import { Link } from "react-router-dom";
import { MdOutlineEmergency } from "react-icons/md";
import { FaRegStar, FaTools } from "react-icons/fa";

const HeadlineTicker = () => {
  const headlines = [
    {
      text: "24/7 Emergency AC Repairs | Lahore & Punjab",
      icon: <MdOutlineEmergency className={styles.headlineIcon} />,
    },
    {
      text: "Top Rated AC Service | 15+ Years Experience",
      icon: <FaRegStar className={styles.headlineIcon} />,
    },
    {
      text: "AC & Refrigeration Specialists | Certified Technicians",
      icon: <FaTools className={styles.headlineIcon} />,
    },
  ];

  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHeadline((prev) => (prev + 1) % headlines.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [headlines.length]);

  return (
    <div className={styles.tickerContainer}>
      <div className={styles.contentWrapper}>
        {!isMobile && (
          <div className={styles.iconContainer}>
            {headlines[currentHeadline].icon}
          </div>
        )}

        <div className={styles.textWrapper}>
          {isMobile ? (
            <span>{headlines[currentHeadline].text}</span>
          ) : (
            <Typewriter
              words={[headlines[currentHeadline].text]}
              loop={false}
              cursor
              cursorStyle="|"
              typeSpeed={40}
              deleteSpeed={30}
              delaySpeed={800}
            />
          )}
        </div>

        <div className={styles.actionContainer}>
          <a href="tel:+923054743725" className={styles.actionLink}>
            <button className={styles.actionButton}>
              <MdOutlineEmergency className={styles.buttonIcon} />
              {isMobile ? "Call Now" : "Emergency Call"}
            </button>
          </a>
          {!isMobile && (
            <div className={styles.phoneInfo}>
              <span>Direct Line:</span>
              <a href="tel:+923054743725" className={styles.phoneNumber}>
                +92 305 4743725
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeadlineTicker;
